module.exports = __webpack_public_path__ + "img/US_BonusDamageProtections_ua.37cbd70d.webp";